var _circle, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasswordresetillustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 185,
    viewBox: "0 0 183 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 87.5,
    r: 62,
    fill: "url(#paint0_linear_12773_4672)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.835 73.977L94.5 67.6194C94.1159 67.4602 93.6841 67.4601 93.3 67.6194L77.9648 73.977C77.3807 74.2192 77 74.7886 77 75.4201V83.1486C77 93.7902 83.4415 103.363 93.3087 107.384C93.6877 107.539 94.1123 107.539 94.4913 107.384C104.358 103.363 110.8 93.7903 110.8 83.1486V75.4201C110.8 74.7886 110.419 74.2192 109.835 73.977ZM92.992 89.6744L100.898 81.7798C101.617 81.0625 102.781 81.0625 103.5 81.7798C104.218 82.4971 104.218 83.6601 103.5 84.3773L94.2927 93.5706C93.5742 94.288 92.4096 94.2878 91.6914 93.5706L86.5506 88.4375C85.8322 87.7202 85.8322 86.5572 86.5506 85.84C87.269 85.1227 88.4337 85.1226 89.152 85.84L92.992 89.6744Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 35.5,
    r: 9,
    fill: "url(#paint1_linear_12773_4672)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 175.5,
    r: 9,
    fill: "url(#paint2_linear_12773_4672)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 154,
    r: 4.5,
    fill: "url(#paint3_linear_12773_4672)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 95,
    r: 4.5,
    fill: "url(#paint4_linear_12773_4672)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9.5,
    r: 9,
    fill: "url(#paint5_linear_12773_4672)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12773_4672",
    x1: 31.9998,
    y1: 87.5003,
    x2: 156.001,
    y2: 87.5003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65098,
    stopColor: "#FE8005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5308"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12773_4672",
    x1: 165,
    y1: 35.5,
    x2: 183,
    y2: 35.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65098,
    stopColor: "#FE8005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5308"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12773_4672",
    x1: 37,
    y1: 175.5,
    x2: 55.0002,
    y2: 175.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65098,
    stopColor: "#FE8005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5308"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12773_4672",
    x1: 152,
    y1: 154,
    x2: 161,
    y2: 154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65098,
    stopColor: "#FE8005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5308"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12773_4672",
    x1: 7.99999,
    y1: 95,
    x2: 17.0001,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65098,
    stopColor: "#FE8005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5308"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12773_4672",
    x1: -0.0000253295,
    y1: 9.50005,
    x2: 18.0002,
    y2: 9.50005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65098,
    stopColor: "#FE8005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5308"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordresetillustration);
export default __webpack_public_path__ + "static/media/password reset illustration.38b049427c4713006f87189b90067711.svg";
export { ForwardRef as ReactComponent };